module.exports = __webpack_public_path__ + "img/logo.bb31347f.png";